<template>
  <div
    class="app-layout app-layout-backend"
    :class="{ 'app-layout-backend--full': hideFooter }"
  >
    <nav-bar @handleDark="toggleDarkMode" />
    <b-container
      fluid
      :class="[
        hideFooter ? '' : { 'text-dark bg-light ': !isDarkMode, 'text-light bg-dark ': isDarkMode },
        { 'app-layout-backend__container--full': hideFooter }
      ]"
    >
      <slot />
      <footer-bar v-if="!hideFooter" />
    </b-container>
  </div>
</template>

<script>
import NavBar from '@/components/NavBar.vue';
import FooterBar from '@/components/FooterBar.vue';
import { mapState, mapActions } from 'vuex';

export default {
  name: 'BackendLayout',
  computed: {
    ...mapState('darkMode', ['isDarkMode']),
    hideFooter() {
      return this.$route.meta.hideFooter === true;
    }
  },
  /* work in only microsoft edge */
  // mounted() {
  //   const darkThemeMq = window.matchMedia('(prefers-color-scheme: dark)');
  //   const isDarkMode = darkThemeMq.matches;

  //   this.changeDarkMode({ isDarkMode });
  //   localStorage.setItem('darkMode', JSON.stringify(isDarkMode));
  // },
  methods: {
    ...mapActions('darkMode', ['changeDarkMode']),
    toggleDarkMode() {
      this.changeDarkMode({ isDarkMode: !this.isDarkMode });
    }
  },
  components: {
    NavBar,
    FooterBar
  }
};
</script>

<style scoped>
.app-layout-backend--full {
  display: flex;
  flex-direction: column;
  height: calc(100vh - 4.5rem);
  overflow: hidden;
}

.app-layout-backend__container--full {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  padding: 0;
  overflow: hidden;
}
</style>
